<template>
  <div v-if="paymentMethod"
       :class="['form-row', 'inline-label', 'payment-issuer', 'payment-issuer-' + paymentMethod.title, 'required']">
    <div class="form-column wm-field-label">
      <label :for="'issuer_' + paymentMethod.title" class="required">
        {{ $t('paymentSelection.issuerLabel.' + paymentMethod.title) }}
      </label>
      <select
        :id="'issuer_' + paymentMethod.title" :name="'issuer_' + paymentMethod.title"
        class="select-bank"
        @change="event => setSelectedPaymentOption(event, paymentMethod)">
        <option :value="null">{{ $t('paymentSelection.selectIssuerOption') }}</option>
        <option
          v-for="(paymentOption, key) in paymentMethod.options"
          :key="key"
          :value="key"
          :selected="(selectedPaymentOption && paymentOption.issuerName === selectedPaymentOption.issuerName)">
          {{ $t('paymentSelection.issuer.' + paymentOption.issuerName) }}
        </option>
      </select>
      <span v-if="validation.$error">
        <ul class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
          <li>{{ $t('paymentSelection.validation.paymentOption.required') }}</li>
        </ul>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentOptionSelectionRow',
  props: {
    validation: {
      type: Object,
      default: null
    },
    paymentMethod: {
      type: Object,
      default: null
    },
    selectedPaymentOption: {
      type: Object,
      default: null
    }
  },
  mounted: function () {
    if (!this.isStoreUser && this.paymentMethod.options.length) {
      this.$store.dispatch(
        'payment/setSelectedPaymentOption',
        this.paymentMethod.options[0]
      )
    }
  },
  methods: {
    setSelectedPaymentOption: function (event, paymentMethod) {
      this.$store.dispatch('payment/setSelectedPaymentOption', paymentMethod.options[event.target.value])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payment-selection/PaymentOptionSelectionRow.vue